import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import {
    StyledTableBody,
    StyledTableColumn,
    StyledTableHeader,
    StyledWrapperTableBody,
} from "app/pages/workspace/sales/components/custom-table/Table/styles";
import {
    StyledTableCell,
    StyledTableHeaderCell,
} from "app/pages/workspace/sales/components/custom-table/TableCell/styles";

export const StyledTable = styled.div`
    margin-top: 10px;

    ${StyledTableHeader} {
        cursor: default;

        ${StyledTableColumn} {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            ${StyledTableHeaderCell} {
                padding: 0 10px;
                height: 32px;
            }
        }
    }
    ${StyledWrapperTableBody} {
        height: 190px;
        overflow: auto;

        ${StyledTableBody} {
            ${StyledTableColumn} {
                ${StyledTableCell} {
                    padding: 0 10px;

                    &:last-child {
                        border-bottom: unset;
                    }
                }
            }
        }
    }
`;

export const StyledSimilarWebCell = styled.div`
    display: flex;
    overflow: hidden;
    align-items: center;
    gap: 4px;

    div:first-child {
        flex: none;
    }
`;

export const StyledExample = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    opacity: 0.6;
    max-width: 400px;
`;

export const StyledInfoIconTooltip = styled.div`
    margin-left: 4px;
    flex: none;
`;

export const StyledSelectedCell = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: right;
`;

export const StyledButtonCheckIcon = styled(IconButton)`
    .SWReactIcons {
        width: 16px;
        height: 16px;
    }

    .SWReactIcons svg path {
        fill: ${colorsPalettes.mint[400]};
    }

    &:hover {
        width: 38px !important;
        height: 38px !important;

        .SWReactIcons svg path {
            fill: ${colorsPalettes.mint[400]};
        }
    }
`;

export const StyledCheckedBlock = styled.div`
    position: relative;
`;
